import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { nameHelper } from 'lib/helpers/name-helper.js';
import { appVersion } from 'src/app/appVersion.js';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';
import { environment } from 'src/app/environments/environment.js';
import { ITypeParentRoute } from 'src/app/pages/type-routes/type-route.models.js';
import { ILayoutMenuItem } from '../layout.models.js';
import { IMenuItemWithState } from '../services/layout-service.js';
import { ExtendedSideMenuCategory, PrimaryMenuType } from './menu.models.js';

@Component({
	selector: 'layout-primary-menu',
	templateUrl: './primary-menu.component.html',
	styleUrls: ['./primary-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class PrimaryMenuComponent extends CoreAppComponent {
	public readonly primaryMenuType = input.required<PrimaryMenuType>();
	public readonly pageTitle = input<string>();
	public readonly toolbarMenuItems = input.required<ILayoutMenuItem[]>();
	public readonly parentRoutes = input.required<readonly ITypeParentRoute[] | undefined>();
	public readonly menuItems = input.required<readonly IMenuItemWithState[] | undefined>();
	public readonly sideMenuCategories = input.required<readonly ExtendedSideMenuCategory[]>();

	public readonly boxDesktopA = environment.primaryMenu.desktop.boxAId;

	protected readonly appCopyright = computed<string>(() => {
		return `© ${this.dependencies.timeService.now().year} ${this.originalAppName()}`;
	});

	protected readonly appVersion = computed<string>(() => {
		return `v${appVersion.version}`;
	});

	public readonly userTitle = computed<string | undefined>(() => {
		const user = this.authUser();

		if (!user) {
			return undefined;
		}

		return nameHelper.getUserName(user.email, user.firstName, user.lastName);
	});

	public readonly userSubtitle = computed<string | undefined>(() => {
		const user = this.authUser();

		if (!user) {
			return undefined;
		}

		if (user.email === this.userTitle()) {
			return user.userType === 'client' ? 'Client' : 'Trainer';
		}

		return user.email;
	});

	public readonly userMenuSubtitle = computed<string | undefined>(() => {
		const user = this.authUser();

		if (!user) {
			return undefined;
		}

		if (user.email === this.userTitle()) {
			return user.userType === 'client' ? 'Client' : 'Trainer';
		}

		return user.email;
	});

	public readonly showMenuOnDesktop = computed<boolean>(() => {
		return this.primaryMenuType() === 'authPage' ? true : false;
	});

	constructor() {
		super();
	}

	handleFeedMenuOpened(): void {
		this.dependencies.layoutService.markFeedsAsRead();
	}
}
